const MENU_DATA = {
  title: ['Our Menu'],
  body: [
    {
      key: 1,
      title: 'Lorem ipsum dolor sit amet',
      body: 'Lorem ipsum dolor sit amet',
      prise: 'Rs 222',
      imgSrc: '/assets/hcmp33562_1459402.png'
    },
    {
      key: 2,
      title: 'Vivamus sodales augue vita',
      body: 'Lorem ipsum dolor sit amet',
      prise: 'Rs 590',
      imgSrc: '/assets/unsplash_ThLVnKdeH1k.png'
    },
    {
      key: 3,
      title: 'Pellentesque semper semper',
      body: 'Lorem ipsum dolor sit amet',
      prise: 'Rs 222',
      imgSrc: '/assets/hcmp33562_1459402.png'
    },
    {
      key: 4,
      title: 'Lorem ipsum dolor sit amet',
      body: 'Lorem ipsum dolor sit amet',
      prise: 'Rs 222',
      imgSrc: '/assets/hcmp33562_1459402.png'
    },
    {
      key: 5,
      title: 'Lorem ipsum dolor sit amet',
      body: 'Lorem ipsum dolor sit amet',
      prise: 'Rs 222',
      imgSrc: '/assets/hcmp33562_1459402.png'
    },
    {
      key: 6,
      title: 'Lorem ipsum dolor sit amet',
      body: 'Lorem ipsum dolor sit amet',
      prise: 'Rs 222',
      imgSrc: '/assets/hcmp33562_1459402.png'
    },
    {
      key: 7,
      title: 'Lorem ipsum dolor sit amet',
      body: 'Lorem ipsum dolor sit amet',
      prise: 'Rs 222',
      imgSrc: '/assets/hcmp33562_1459402.png'
    },
    {
      key: 8,
      title: 'Vivamus sodales augue vita',
      body: 'Lorem ipsum dolor sit amet',
      prise: 'Rs 590',
      imgSrc: '/assets/unsplash_ThLVnKdeH1k.png'
    },
    {
      key: 9,
      title: 'Pellentesque semper semper',
      body: 'Lorem ipsum dolor sit amet',
      prise: 'Rs 222',
      imgSrc: '/assets/hcmp33562_1459402.png'
    },
    {
      key: 10,
      title: 'Lorem ipsum dolor sit amet',
      body: 'Lorem ipsum dolor sit amet',
      prise: 'Rs 222',
      imgSrc: '/assets/hcmp33562_1459402.png'
    },
    {
      key: 11,
      title: 'Lorem ipsum dolor sit amet',
      body: 'Lorem ipsum dolor sit amet',
      prise: 'Rs 222',
      imgSrc: '/assets/hcmp33562_1459402.png'
    },
    {
      key: 12,
      title: 'Lorem ipsum dolor sit amet',
      body: 'Lorem ipsum dolor sit amet',
      prise: 'Rs 222',
      imgSrc: '/assets/hcmp33562_1459402.png'
    }
  ]
};

export default MENU_DATA;